import Create from '../../../base/errors/user/Create';

const create: Create = {
  GeneralError: 'Bei der Verarbeitung der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an die Calypso group mit dem Fehlercode <{trackingId}>.',
  DuplicateUserName: 'Benutzername existiert bereits',
  UnableToSetNotificationChannel: 'Der Benutzer wurde erfolgreich erstellt, der Benachrichtigungskanal konnte jedoch nicht festgelegt werden. Versuchen Sie es später noch einmal.'
};

export default create;
